import { useQuery } from '@tanstack/react-query';
import { ImageOff } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useApi, useApiProblem } from '@/shared/api';

/**
 * Vorschaubild für die Verwaltung — über den Admin-Endpunkt. Ein beschädigtes Foto sagt, was zu tun
 * ist; jeder andere Fehler zeigt einen ruhigen Ersatz statt eines Schimmers ohne Ende.
 */
export function ResourceImageThumb(props: {
  groupId: string;
  resourceId: string;
  imageId: string;
}) {
  const api = useApi();
  const blob = useQuery({
    queryKey: ['resource-image', props.imageId, 'thumb'],
    queryFn: () => api.resources.images.content(props.groupId, props.resourceId, props.imageId),
    staleTime: Infinity,
  });
  const problem = useApiProblem(blob.error);
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob.data) return;
    const objectUrl = URL.createObjectURL(blob.data);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob.data]);

  if (blob.isError) {
    const broken = problem?.title === 'resource_image_unavailable';
    return (
      <div
        className="bg-card-alt text-ink-soft flex aspect-square w-full flex-col items-center justify-center gap-1 rounded-md p-2 text-center text-[12px]"
        role="img"
        aria-label={broken ? 'Foto beschädigt' : 'Vorschau nicht geladen'}
      >
        <ImageOff size={18} strokeWidth={1.75} aria-hidden />
        {broken && <span>Foto beschädigt – bitte entfernen und neu hochladen.</span>}
      </div>
    );
  }
  if (!url) return <div className="bg-card-alt aspect-square w-full animate-pulse rounded-md" />;
  return <img src={url} alt="" className="aspect-square w-full rounded-md object-cover" />;
}
